﻿import React, { useState, useEffect } from 'react';
import { ContractAgency } from '../../models/TablesManagement/contract-agency';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import GlobalDialog from '../Modal/GlobalDialog';

import DataGrid, {
    Column,
    FilterRow,
    GroupPanel,
    Selection,
    HeaderFilter,
    Editing,
    Popup,
    Form,
    Toolbar,
    Item as ToolbarItem,
    Button as ColumnButton,
    Paging,
    Scrolling,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Item } from 'devextreme-react/form';
import { Button } from 'devextreme-react/button';
import { Toast } from 'devextreme-react/toast';

export interface Props {
    title: string;
}

export default function ContractAgenciesTableManagementForm(props: Props) {
    const [contractAgencies, setContractAgencies] =
        useState<ContractAgency[]>();

    const [toastVisible, setToastVisible] =
        useState<boolean>();

    const [toastMessage, setToastMessage] =
        useState<string>();

    const [toastType, setToastType] =
        useState<any>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getContractAgencies();
    }, []);

    const gridWidth = 'calc(90vw - 13em)';

    return (
        <div>
            <DataGrid width={gridWidth}
                height="65vh"
                keyExpr="vendorId"
                dataSource={contractAgencies ? contractAgencies : []}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnResizingMode='widget'
                onRowValidating={onContractAgencyRowValidating}
                rowAlternationEnabled={true}
                showRowLines={true}
                showBorders={true} >

                <LoadPanel enabled={true} />
                <Paging enabled={false} />
                <Selection mode='single' />
                <HeaderFilter visible={true} />
                <FilterRow visible={true} />
                <GroupPanel visible={false} />
                <SearchPanel visible={true} />
                <Scrolling columnRenderingMode='virtual' />

                <Column type="buttons" width={"5rem"}>
                    <ColumnButton name="edit" />
                </Column>

                <Column dataField='name' width={'20%'} />

                <Toolbar>
                    <ToolbarItem location='before'>
                        <div className="pw-datagrid-toolbar-template">
                            <div className="pw-datagrid-toobar-title">{props.title}</div>
                        </div>
                    </ToolbarItem>
                    <ToolbarItem name="addRowButton" location='after' />
                    <ToolbarItem name="searchPanel" location='after' />
                </Toolbar>

                <Editing
                    mode="popup"
                    useIcons={true}
                    allowAdding={true}
                    allowUpdating={true}
                    allowDeleting={false} >

                    <Popup title={props.title} showTitle={true} width='80vw' height='80vh' />
                    <Form>
                        <Item dataField="name" colSpan={2} />
                    </Form>

                </Editing>
            </DataGrid >

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    async function onContractAgencyRowValidating(e: any) {
        if (e.oldData) {
            let contractAgency = e.oldData as ContractAgency;

            if (contractAgency) {
                let updatedContractAgency = { ...contractAgency, ...e.newData };

                await updateContractAgency(updatedContractAgency)
                    .then(() => {
                        showToast("ContractAgency updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating ContractAgency");
                    });
            }
        }
        else {
            if (e.newData) {
                let contractAgency = e.newData as ContractAgency;

                if (contractAgency) {
                    await insertContractAgency(contractAgency)
                        .then(data => {
                            showToast("Contract Agency saved", "success");
                            getContractAgencies();
                        })
                        .catch(res => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Contract Agency");
                        });
                }
            }
        }
    }

    async function getContractAgencies() {
        await CrudFunctions.getData("common/contractagencies")
            .then((data) => {
                setContractAgencies(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Contract Agencies");
            });
    }

    async function insertContractAgency(contractAgency: ContractAgency) {
        return await CrudFunctions.postData("common/contractagency", contractAgency)
    }

    async function updateContractAgency(contractAgency: ContractAgency) {
        return await CrudFunctions.putData("common/contractagency", contractAgency)
    }

    //show/hide

    function onToastHiding() {
        setToastVisible(false);
        setToastMessage(undefined);
        setToastType(undefined);
    }

    function showToast(message: string, toastType: string) {
        setToastMessage(message);
        setToastType(toastType);
        setToastVisible(true);
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}


